export function parseNumber(value) {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  const cleanedValue = String(value).replace(/[$,%\s,]/g, '');
  const number = Number(cleanedValue);

  return Number.isFinite(number) ? number : 0;
}

export function formatCurrency(value, options = {}) {
  const { showSign = false, maximumFractionDigits = 0 } = options;

  const number = parseNumber(value);
  const sign = showSign && number > 0 ? '+' : '';

  return `${sign}${number.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
  })}`;
}

export function formatPercent(value, options = {}) {
  const { maximumFractionDigits = 1 } = options;

  const number = Number(value);

  if (!Number.isFinite(number)) {
    return '—';
  }

  return `${number.toFixed(maximumFractionDigits)}%`;
}

export function formatDate(value) {
  if (!value) return '—';

  const textValue = String(value).trim();

  /*
    Backend calendar dates like "2026-05-21" must be treated as
    plain dates, not JS Date objects. new Date("2026-05-21")
    parses as UTC midnight and can display as 5/20 locally.
  */
  const dateOnlyMatch = textValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;

    return `${Number(month)}/${Number(day)}/${String(year).slice(-2)}`;
  }

  const date = new Date(textValue);

  if (Number.isNaN(date.getTime())) {
    return textValue;
  }

  return date.toLocaleDateString(undefined, {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
  });
}

export function formatTradeResult(value) {
  if (!value) return 'Closed';

  const normalized = String(value).trim().toUpperCase();

  if (normalized === 'WIN') return 'Win';
  if (normalized === 'LOSS') return 'Loss';
  if (normalized === 'OPEN') return 'Open';
  if (normalized === 'CLOSED') return 'Closed';

  return String(value);
}